<template>
  <div class="main">
    <div class="col-gauche">
      <img src="../assets/overlayLogin.png" alt="image emotion culturel" />
    </div>
    <div class="col-droite">
      <div v-if="false">
        L'espace client sera non disponible pour quelques heures. Veuillez réessayer plus tard. Merci!
      </div>
      <form @submit="onSubmit">
        <div class="field">
          <label for="courriel">Courriel<span>*</span></label>
          <input
            type="email"
            name="courriel"
            v-model="form.email"
            id="courriel"
            placeholder="Courriel*"
            autocomplete="username"
            required
          />
        </div>

        <div class="field">
          <div class="passwordCtn">
            <label for="password">Mot de passe<span>*</span></label>
            <input
              class="password"
              v-model="form.password"
              :type="passwordSecret"
              name="password"
              id="password"
              placeholder="Mot de passe*"
              autocomplete="current-password"
              required
            />
            <img
              v-if="passwordSecret == 'password'"
              src="../assets/invisible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('visible')"
            />
            <img
              v-if="passwordSecret == 'text'"
              src="../assets/visible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('invisible')"
            />
          </div>
          <a @click="toReset" class="link">Mot de passe oublié ?</a>
        </div>

        <input class="btn-submit" type="submit" value="Se connecter" />
        <p>
          Vous n'avez pas de compte ? <br />
          <a @click="toSignup" class="link">Créez votre compte </a>
          dès maintenant !
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      passwordSecret: "password",
      form: {},
      redirectUri: undefined,
    };
  },
  watch: {
    loggedIn() {
      if (this.loggedIn === true) {
        if(this.redirectUri)
        {
          window.location.href = this.redirectUri+"?pagetype=connected";

        }
        else
        {
          this.$router.push("/?pagetype=connected")
        }
      }
    },
  },
  methods: {
    switchPasswordSecret(state) {
      if (state == "visible") {
        this.passwordSecret = "text";
      }
      if (state == "invisible") {
        this.passwordSecret = "password";
      }
    },
    ...mapActions(["login", "validation"]),
    onSubmit(event) {
      event.preventDefault();
      this.login(this.form);
    },
    toSignup() {
      if (this.redirectUri) {
        this.$router.push("/signup?redirectUri=" + this.redirectUri);
      } else {
        this.$router.push({
          name: "Signup",
        });
      }
    },
    toReset() {
      this.$router.push({
        name: "Reset",
      });
    },
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.status.loggedIn,
    }),
  },
  mounted() {
    this.redirectUri = this.$route.query.redirectUri;
    if (this.loggedIn === true) {
      window.location  = window.location.href.split("/")[0] +"/"+"/"+window.location.href.split("/")[2]+"/" ;
    }
  },
  created() {
    if (this.$route.query.validateToken) {
      this.validation({ token: this.$route.query.validateToken });
    }
  },
};
</script>

<style scoped src="../assets/styleLogin.css">
.remember {
  display: flex;
  align-items: center;
}
.checkbox {
  -webkit-appearance: none;
  border: 1px solid black;
  padding: 10px;
  display: inline-block;
  position: relative;
}
.checkbox:hover {
  cursor: pointer;
}
.checkbox:active,
.checkbox:checked:active {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px 1px 3px rgba(0, 0, 0, 0.1);
}
.checkbox:checked {
  border: 1px solid black;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),
    inset 15px 10px -12px rgba(255, 255, 255, 0.1);
  color: #99a1a7;
}
.checkbox:checked:after {
  content: "\2713";
  font-size: 16px;
  position: absolute;
  color: black;
  top: 0;
  left: 3px;
}
</style>
